import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule, Router, Routes } from '@angular/router';
import { EmeraldTabBarModule } from '@emerald-angular/tab-bar';
import { EmeraldButtonModule } from '@emerald-angular/button';
import { EmeraldDatatableModule } from '@emerald-angular/datatable';
import { EmeraldIconModule } from '@emerald-angular/icon';
import { EmeraldInputModule } from '@emerald-angular/input';
import { EmeraldDropdownModule } from '@emerald-angular/dropdown';
import { HiringManagerOpenpositionsComponent } from './hiring-manager-openpositions/hiring-manager-openpositions.component';
import { JobDetailsComponent } from './job-details/job-details.component';
import { EmeraldModalModule } from '@emerald-angular/modal';
import { EmeraldDatepickerModule } from '@emerald-angular/datepicker';
import { ReactiveFormsModule } from '@angular/forms';
import { HiringManagerCandidatesComponent } from './hiring-manager-candidates/hiring-manager-candidates.component';
import { HiringRequestComponent } from './hiring-request/hiring-request.component';
import { EmeraldDividerModule } from '@emerald-angular/divider';
import { CandidateFeedbackComponent } from '@shared/modals/candidate-feedback/candidate-feedback.component';
import { EmeraldAccordionGroupModule } from '@emerald-angular/accordion-group';
import { SharedModule } from '@shared/shared.module';
import { AuthGuard } from '@core/okta-auth.guard';
import { FormsModule } from '@angular/forms';
import { EmeraldTooltipModule } from '@emerald-angular/tooltip';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { OpenPositionFilterComponent } from '@shared/modals/open-position-filter/open-position-filter.component';
import { JobDetailsFilterComponent } from '@shared/modals/job-details-filter/job-details-filter.component';
import { CandidateFilterComponent } from '@shared/modals/candidate-filter/candidate-filter.component';
import { AddHttpsPipe } from '@shared/pipes/add-https.pipe';
import { OpenPositionsFlagLegendComponent } from '@shared/components/open-positions-flag-legend/open-positions-flag-legend.component';
import { TruncatetextpipePipe} from '@shared/pipes/truncatetextpipe.pipe';
import { ModalWrapperComponent } from '@shared/components/modal-wrapper/modal-wrapper.component';

const routes: Routes = [
  {
    path: 'hiring-manager',
    canActivate: [AuthGuard],
    children: [
      { path: '', component: HiringManagerOpenpositionsComponent },
      { path: 'openpositions', component: HiringManagerOpenpositionsComponent },
      { path: 'hiringrequest', component: HiringRequestComponent },
      { path: 'job-details', component: JobDetailsComponent },
      { path: '**', redirectTo: '', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    EmeraldTabBarModule,
    EmeraldButtonModule,
    EmeraldDatatableModule,
    EmeraldIconModule,
    EmeraldInputModule,
    ReactiveFormsModule,
    EmeraldDropdownModule,
    EmeraldDatepickerModule,
    EmeraldModalModule,
    EmeraldDividerModule,
    EmeraldAccordionGroupModule,
    RouterModule,
    SharedModule,
    RouterModule.forChild(routes),
    OpenPositionFilterComponent,
    OpenPositionsFlagLegendComponent,
    JobDetailsFilterComponent,
    CandidateFilterComponent,
    CandidateFeedbackComponent,
    FormsModule,
    EmeraldTooltipModule,
    NgxSkeletonLoaderModule,
    AddHttpsPipe,
    TruncatetextpipePipe,
    ModalWrapperComponent,
  ],

  declarations: [
    HiringManagerOpenpositionsComponent,
    HiringRequestComponent,
    JobDetailsComponent,
    HiringManagerCandidatesComponent,
  ],
})
export class HiringManagerOpenpositionsModule {}
